module.exports = __webpack_public_path__ + "img/etiquetado8.26a9348b.jpg";